import React, { useEffect, useRef } from 'react';
import backgroundImage from './assets/logo_bg.svg';
import BottomSection from './components/BottomSection';
import DrawingCanvas from './components/DrawingCanvas';
import DrawModeSettings from './components/DrawModeSettings';
import ExcalidrawCanvas from './components/ExcalidrawCanvas';
import InfoOverlay from './components/InfoOverlay';
import LeftSection from './components/LeftSection';
import ProgressBar from './components/ProgressBar';
import RightSection from './components/RightSection';
import ScreenshotDisplay from './components/ScreenshotDisplay';
import TopSection from './components/TopSection';
import useLayersStore from './stores/layersStore';

function App() {
  // Use specific selectors to avoid unnecessary re-renders
  const isDrawingMode = useLayersStore((state) => state.isDrawingMode);
  const branding = useLayersStore((state) => state.branding);
  const isExDrawingMode = useLayersStore((state) => state.isExDrawingMode);
  const screenshot = useLayersStore((state) => state.screenshot);
  const featureEnabled = useLayersStore((state) => state.featureEnabled);
  
  // Debug what's changing
  const prevValues = useRef({ isDrawingMode, branding, isExDrawingMode, screenshot });
  useEffect(() => {
    const changes = [];
    if (prevValues.current.isDrawingMode !== isDrawingMode) changes.push('isDrawingMode');
    if (prevValues.current.branding !== branding) changes.push('branding');
    if (prevValues.current.isExDrawingMode !== isExDrawingMode) changes.push('isExDrawingMode');
    if (prevValues.current.screenshot !== screenshot) {
      changes.push('screenshot');
      console.log('Screenshot changed:', {
        prev: prevValues.current.screenshot ? 'has data' : 'null',
        current: screenshot ? 'has data' : 'null',
        prevLength: prevValues.current.screenshot?.length || 0,
        currentLength: screenshot?.length || 0
      });
    }
    
    if (changes.length > 0) {
      console.log('App re-render caused by:', changes);
    }
    
    prevValues.current = { isDrawingMode, branding, isExDrawingMode, screenshot };
  });
  
  console.log('App rendering - isExDrawingMode:', isExDrawingMode, 'isDrawingMode:', isDrawingMode, 'screenshot:', !!screenshot);

  console.log("DEBUG -- app Logout Branding, backgroundColor: ", branding.backgroundColor);
  console.log("DEBUG -- app Logout Branding, backgroundLogo: ", branding.backgroundLogo);
  console.log("DEBUG -- app Logout Branding, loadingLogo: ", branding.loadingLogo);
  console.log("DEBUG -- app Logout Branding, primaryColor: ", branding.primaryColor);

  return (
    <div className="App" style={{ height: '100vh', width: '100vw', overflow: 'hidden' }}>
      <ProgressBar />
      <div
        id="v3d-container"
        className="absolute overflow-hidden top-0 left-0 w-full h-full z-20"
      ></div>
      <div
        id="v3d-anno-container"
        className="absolute overflow-hidden top-0 left-0 w-full h-full z-30 pointer-events-none"
      ></div>
      <div
        id="v3d-branding-container"
        className={`absolute top-0 left-0 h-screen w-screen ${isExDrawingMode ? 'hidden' : ''}`}
        style={{
          background: !featureEnabled.background && !featureEnabled.backgroundColor
            ? 'transparent'
            : branding.backgroundLogo && featureEnabled.background
              ? branding.backgroundColor && featureEnabled.backgroundColor
                ? `url(${branding.backgroundLogo}) no-repeat center center / contain, ${branding.backgroundColor}`
                : `url(${branding.backgroundLogo}) no-repeat center center / contain, linear-gradient(134deg, #ff4091 -25%, #4939de 35%, #fd60ff 135%)`
              : branding.backgroundColor && featureEnabled.backgroundColor
                ? `${branding.backgroundColor}`
                : `url(${backgroundImage}) no-repeat -140% 26% / 115%, linear-gradient(134deg, #ff4091 -25%, #4939de 35%, #fd60ff 135%)`,
        }}
      >
        <TopSection />
        <LeftSection />
        <RightSection />
        <BottomSection />
      </div>
      {isDrawingMode && (
        <>
          <DrawingCanvas />
          <DrawModeSettings />
        </>
      )}
      {isExDrawingMode && (
        <ExcalidrawCanvas />
      )}
      {screenshot && (
        <ScreenshotDisplay />
      )}
            <InfoOverlay />
    </div>
  );
}

export default App;
